import { Box, Stack, useTheme } from '@mui/material';

import { AdditionalFeatures } from './components/AdditionalFeatures';
import Header from './components/Header';
import MessageInput from './components/MessageInput';
import MessageStack from './components/MessageStack';

const Chat = () => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                flex: 1,
                minHeight: 0, //This allows messages to be added without the container growing
                background: theme.gradients.primaryRadialGradient,
                borderRadius: theme.borderRadius.small,
            }}
            p={theme.borderWidth.thin}
        >
            <Stack
                component='article'
                sx={{
                    height: '100%',
                    backgroundColor: theme.palette.common.white,
                    borderRadius: `calc(${theme.borderRadius.small} - ${theme.borderWidth.thin})`,
                }}
                gap={1}
            >
                <Header />
                <MessageStack />
                <MessageInput />
                <AdditionalFeatures />
            </Stack>
        </Box>
    );
};

export default Chat;
